import { createContext, Dispatch } from 'react';
import { getInitialSearchMockState } from './store/store.action';
import { InitialSearchResult } from './store/store.reducer';
import { UpdateSearchStateActionType, SearchStateStoreDataType, SearchResultDataType } from './store/store.type';
import { SearchResultAlertType } from './index.types';
import { hardCodedAllLocale } from '../../lib/organisms/SearchForm/component/index.constants';

interface SearchFilterContextType {
  searchQueryState: SearchStateStoreDataType;
  setSearchQuery: Dispatch<UpdateSearchStateActionType>;
  filterModalOpen: boolean;
  setFilterModalOpen: (open: boolean) => void;
}

interface SearchResultContextType {
  searchResult: SearchResultDataType;
  setSearchResult: Dispatch<UpdateSearchStateActionType>;
}

export const SearchFilterContext = createContext<SearchFilterContextType>({
  searchQueryState: getInitialSearchMockState({}, false, hardCodedAllLocale.en, '', false, '', false),
  setSearchQuery: () => {
    //TODO : empty function
  },
  filterModalOpen: false,
  setFilterModalOpen: () => {
    //TODO : empty function
  },
});

export const SearchResultContext = createContext<SearchResultContextType>({
  searchResult: InitialSearchResult,
  setSearchResult: () => {
    //TODO : empty function
  },
});

interface SearchResultAlertContextType {
  searchResultAlerts: SearchResultAlertType;
  setSearchResultAlerts: Dispatch<SearchResultAlertType>;
}
export const SearchResultAlertContext = createContext<SearchResultAlertContextType>({
  searchResultAlerts: {},
  setSearchResultAlerts: () => {
    //TODO : empty function
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MapViewContext = createContext<any>({
  selectedHotel: [],
  setSelectedHotel: () => {
    //TODO : empty function
  },

  open: false,
  setOpen: () => {
    //TODO : empty function
  },
});
